<template>
 <div class="tip">
   <el-dialog
      :visible.sync="showDialog"
      :showClose="false"
      :close-on-click-modal ='false'
      :modal-append-to-body='false'>
      <img src="../assets/images/application/empty.png" alt="">
      <span>{{tipMessage}}</span>
    </el-dialog>
 </div>
</template>
<script>
export default {
  props: {
    showDialog: {
      type: [Boolean]
    },
    tipMessage:{
      type:[String]
    },
  },
  name: "tip",
  data() {
    return {
      active:false,
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/index.scss";
.tip{
  .el-dialog{
    width: 608px;
    //height: 200px;
    .el-dialog__body{
      height: 100%;
      padding: 65px 140px;
      display: flex;
      width: 100%;
      align-items: center;
      margin: 0px auto;
      img{
      width: 90px;
      height: 90px;
      margin-right: 20px;
     }
     span{
       font-size: 36px;
       color: #333333;
     }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tip.vue